var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.1667H7.08333V15.5833H0V14.1667ZM0 9.91667H7.08333V11.3333H0V9.91667ZM15.5833 7.08333H1.41667C1.04094 7.08333 0.680609 6.93408 0.414932 6.6684C0.149255 6.40272 0 6.04239 0 5.66667V1.41667C0 1.04094 0.149255 0.680609 0.414932 0.414932C0.680609 0.149255 1.04094 0 1.41667 0H15.5833C15.9591 0 16.3194 0.149255 16.5851 0.414932C16.8507 0.680609 17 1.04094 17 1.41667V5.66667C17 6.04239 16.8507 6.40272 16.5851 6.6684C16.3194 6.93408 15.9591 7.08333 15.5833 7.08333ZM1.41667 1.41667V5.66667H15.5833V1.41667H1.41667ZM15.5833 17H11.3333C10.9576 17 10.5973 16.8507 10.3316 16.5851C10.0659 16.3194 9.91667 15.9591 9.91667 15.5833V11.3333C9.91667 10.9576 10.0659 10.5973 10.3316 10.3316C10.5973 10.0659 10.9576 9.91667 11.3333 9.91667H15.5833C15.9591 9.91667 16.3194 10.0659 16.5851 10.3316C16.8507 10.5973 17 10.9576 17 11.3333V15.5833C17 15.9591 16.8507 16.3194 16.5851 16.5851C16.3194 16.8507 15.9591 17 15.5833 17ZM11.3333 11.3333V15.5833H15.5833V11.3333H11.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.e1d2f3f8066af1f42165fb03bd7a5b89.svg";
export { ForwardRef as ReactComponent };